//declare var Swiper: any
declare var $

import Swiper from 'swiper';
import { Navigation, EffectCreative, Autoplay } from 'swiper/modules';
//import 'swiper/css';
//import 'swiper/css/navigation';

export class SwiperCarousel {

	el: HTMLElement
	swiper: Swiper

	constructor(el) {
		this.el = el
		this.init()
    // this.card()
	}

	init() {

    const defaultBreakpoints = {
      320: {
        slidesPerView: 1,
        spaceBetween: 16,
        creativeEffect: {
            next: {
                translate: ['calc(100% + 16px)', 0, 0],
            },
            limitProgress: 2.15
        }
      },
      400: {
        slidesPerView: 1,
        spaceBetween: 16,
        creativeEffect: {
            next: {
                translate: ['calc(100% + 16px)', 0, 0],
            },
            limitProgress: 2.1
        }
      },
      768: {
        slidesPerView: 1,
        spaceBetween: 16,
        creativeEffect: {
            next: {
                translate: ['calc(100% + 16px)', 0, 0],
            },
            limitProgress: 3
        }
      },
      1024: {
        slidesPerView: 1,
        spaceBetween: 16,
        creativeEffect: {
            next: {
                translate: ['calc(100% + 16px)', 0, 0],
            },
            limitProgress: 4
        }
      },
      /*
      1366: {
        slidesPerView: 1.33,
        spaceBetween: 24,
        creativeEffect: {
            next: {
                translate: ['calc(100% + 24px)', 0, 0],
            },
            limitProgress: 4
        }
      },
      1600: {
        slidesPerView: 1.33,
        spaceBetween: 24,
        creativeEffect: {
            next: {
                translate: ['calc(100% + 24px)', 0, 0],
            },
            limitProgress: 4
        }
      }
      */
    }


		this.swiper = new Swiper(this.el, {
      effect: "creative",
      creativeEffect: {
        prev: {
          shadow: true,
          translate: [0, 0, -100],
          opacity: 0
        },
        next: {
          translate: ['calc(100% + 16px)', 0, 0],
        },
        limitProgress: 2.1
      },
      slidesPerView: 1.1,
      allowTouchMove: true,
      autoplay: true,
      speed: 1000,
      loopFillGroupWithBlank: true,
      watchSlidesProgress: true,
      modules: [ Navigation, EffectCreative, Autoplay ],
      breakpoints: defaultBreakpoints,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
		});
	}

}